"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select } from "@radix-ui/themes";
import * as React from "react";
import { SelectContent, SelectItem, SelectTrigger } from "./elements";
import { useUsersManagementContext } from "./users-management-context";
const ALL_ROLES_NAME = "All";
const ALL_ROLES_VALUE = "null";
export const UsersFilter = ({ roles, disabled, }) => {
    const { dispatch, state: { role }, } = useUsersManagementContext();
    const setFilterParams = (value) => {
        dispatch({ type: "FILTER_BY_ROLE", role: value });
    };
    const isValidRole = (value) => roles ? roles.findIndex((role) => role.slug === value) !== -1 : false;
    const filteredRole = isValidRole(role) ? role : ALL_ROLES_VALUE;
    const roleName = roles?.find((role) => role.slug === filteredRole)?.name || ALL_ROLES_NAME;
    const onValueChange = (value) => {
        if (value === ALL_ROLES_VALUE) {
            setFilterParams(null);
        }
        else {
            if (isValidRole(value)) {
                setFilterParams(value);
            }
        }
    };
    return (_jsxs(Select.Root, { value: roles ? filteredRole : "null", onValueChange: onValueChange, disabled: disabled, children: [_jsx(SelectTrigger, { children: roles ? roleName : ALL_ROLES_NAME }), _jsxs(SelectContent, { children: [_jsx(SelectItem, { value: ALL_ROLES_VALUE, children: ALL_ROLES_NAME }), roles?.map((role) => (_jsx(React.Fragment, { children: _jsx(SelectItem, { value: role.slug, children: role.name }) }, role.slug)))] })] }));
};
//# sourceMappingURL=users-filter.js.map